/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import { call, put, takeEvery, select } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import { createSelector } from 'reselect';
import seoDataAbstractor from '../../services/abstractors/seoData';
import catSeoDataAbstractor from '../../services/abstractors/catSeoData';
import GLOBAL_CONSTANTS, { SEO_DATA } from '../constants';
import { SEO_DATA_REDUCER_KEY } from '../../constants/reducer.constants';
import { setSEOData } from '../actions';
import { setCategoryPageSeoData } from '../../components/features/browse/ProductListing/container/ProductListing.actions';
import PRODUCTLISTING_CONSTANTS from '../../components/features/browse/ProductListing/container/ProductListing.constants';
import CATEGORY_LISTING_PAGE_CONSTANTS from '../../components/features/browse/CategoryListingPage/container/CategoryListingPage.constants';
import { setCategoryPageSeoDetails } from '../../components/features/browse/CategoryListingPage/container/CategoryListingPage.actions';
import { setHorizontalPageSEOData } from '../../components/features/browse/HorizontalCategory/container/HorizontalCategory.actions';
import { setSeoHeaderCopy } from '../../components/common/organisms/StyliticsProductTabList/container/StyliticsProductTabList.actions';
import { defaultChannel } from '../../services/api.constants';
import { removeHyphensFromUrl } from '../../utils/utils';

const ignoreSEODuplicates = ['store', 'help-center', 'content'];

const seoDataReducerSelector = (state) => state[SEO_DATA_REDUCER_KEY];

const seoDataSelector = createSelector(
  [seoDataReducerSelector, (_, page) => page],
  (seoDataReducer, page) => {
    const seoDataKey = page && page.split('/')[1];
    if (ignoreSEODuplicates.includes(seoDataKey)) {
      return false;
    }
    const pageData = seoDataReducer && seoDataReducer[seoDataKey];
    return pageData || false;
  }
);

function* fetchPageSEOData(action) {
  const { payload: { page, apiConfig } = {} } = action;
  const state = yield select();
  const isSEODataExist = yield call(seoDataSelector, state, page);
  if (!isSEODataExist) {
    const { siteIdCMS: country, brandIdCMS: brand, language: lang } = apiConfig;
    const seoDataParams = {
      page,
      brand,
      channel: defaultChannel,
      country,
      lang: lang === 'en' ? '' : lang,
    };

    const data = yield call(seoDataAbstractor.getData, SEO_DATA.seoData, seoDataParams, apiConfig);
    yield put(setSEOData({ page, data }));
  }
}

const transformOutfitPageSEO = (page) => {
  if (page.includes('_outfits')) {
    const hyphenBasedPage = page.split('_').join('-');
    if (hyphenBasedPage.includes('-gallery')) {
      return hyphenBasedPage.split('-gallery')[0];
    }
    return hyphenBasedPage;
  }
  return page;
};

function* fetchCategoryPageSeoData(action) {
  const {
    payload: {
      apiConfig,
      page,
      isCategoryPage = false,
      isHorizontalPage = false,
      catId = '',
      fromOutfit = false,
    },
  } = action;

  const { siteIdCMS: country, brandIdCMS: brand, language } = apiConfig;
  try {
    if (page && page.length) {
      const pageNameInStore = removeHyphensFromUrl(page);
      const state = yield select();
      const dataInState = yield call(seoDataSelector, state, page);
      if (!dataInState) {
        const seoPageUrl = transformOutfitPageSEO(page);
        const response = yield call(
          catSeoDataAbstractor.getData,
          SEO_DATA.categorySeoData,
          { url: seoPageUrl, brand, country, lang: language === 'en' ? '' : language },
          apiConfig
        );
        if (isCategoryPage) {
          yield put(setCategoryPageSeoDetails({ page: pageNameInStore, response }));
        } else if (isHorizontalPage) {
          const seoHeaderCopy = response?.categorySeoData?.seoHeaderCopy;
          if (seoHeaderCopy) {
            const obj = { catId, seoHeaderCopy };
            yield put(setHorizontalPageSEOData(obj));
          }
        } else if (fromOutfit) {
          const seoHeaderCopy = response?.categorySeoData?.seoHeaderCopy;
          if (seoHeaderCopy) {
            const obj = { page, seoHeaderCopy };
            yield put(setSeoHeaderCopy(obj));
          }
        } else {
          yield put(setCategoryPageSeoData({ page: pageNameInStore, response }));
        }
      }
    }
  } catch (error) {
    logger.error('Error in fetchCategoryPageSeoData', {
      error,
      extraData: {
        component: 'Layout saga - fetchCategoryPageSeoData',
        payloadRecieved: { pageName: page },
      },
    });
  }
}

function* SEODataSaga() {
  yield takeEvery(GLOBAL_CONSTANTS.LOAD_PAGE_SEO_DATA, fetchPageSEOData);
  yield takeEvery(PRODUCTLISTING_CONSTANTS.LOAD_CATEGORY_PAGE_SEO_DATA, fetchCategoryPageSeoData);
  yield takeEvery(
    CATEGORY_LISTING_PAGE_CONSTANTS.LOAD_CATEGORY_PAGE_SEO_DATA,
    fetchCategoryPageSeoData
  );
}

export default SEODataSaga;
